// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"AssetsList_tableContainer__1dj_b","cardTitle":"AssetsList_cardTitle__3WEoU","table":"AssetsList_table__2zvue"};